import { AxiosInstance } from 'axios';
import { PastEventsService as BasePastEventsService } from '@sweatpals/data-services';
import {
	ListWithTotals,
	PastEventDto,
	PastEventsFilter,
	PastEventsWithGroupedDraftsDto,
	UsersToPastEventsFilter,
} from '@sweatpals/shared';
import { last, size, slice } from 'lodash-es';

export class PastEventsService {
	httpClient: AxiosInstance;
	baseService: BasePastEventsService;

	constructor(httpClient: AxiosInstance) {
		this.httpClient = httpClient;
		this.baseService = new BasePastEventsService(httpClient);
	}

	public async getPastEvents(filter: PastEventsFilter): Promise<ListWithTotals<PastEventDto>> {
		const { data } = await this.baseService.getPastEvents(filter);

		return data;
	}

	public async getEvents(filter: UsersToPastEventsFilter): Promise<PastEventsWithGroupedDraftsDto> {
		const { data } = await this.baseService.getEvents(filter);

		return data;
	}

	public async getPastEventsForDashboard(filter: PastEventsFilter): Promise<ListWithTotals<PastEventDto>> {
		const { data } = await this.baseService.getPastEventsForDashboard(filter);

		return data;
	}

	private buildPastEvents(events: PastEventDto[], limit?: number) {
		const sliced = slice(events, 0, limit && limit - 1);

		const mapped = sliced;

		const totalCount = size(events);

		return {
			totalCount,
			hasMore: limit ? totalCount > (limit - 1) : false,
			data: sliced,
			lastEventId: last(mapped)?.id || '',
		};
	}
}
